import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { EDITIONS, getProductEditionData } from './constants/inventoryConstants';

// TODO: Remove this once https://git.hubteam.com/HubSpot/settings-ui-user-record/pull/49/files is merged

const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;
const editionLevels = {
  [EDITIONS.FREE]: 1,
  [EDITIONS.STARTER]: 2,
  [EDITIONS.PROFESSIONAL]: 3,
  [EDITIONS.ENTERPRISE]: 4
};
export function getHighestOwnedEditionForHub(desiredHub, products) {
  let hubEdition = EDITIONS.FREE;
  if (products) {
    products.forEach(({
      productApiName
    }) => {
      const {
        hub,
        edition
      } = getProductEditionData(productApiName);
      if (!hub || !edition || desiredHub !== hub) {
        return;
      }
      if (editionLevels[edition] > editionLevels[hubEdition]) {
        hubEdition = edition;
      }
    });
  }
  return hubEdition;
}
export function getHasPaidHubProduct(hub, products) {
  const highestEdition = getHighestOwnedEditionForHub(hub, products);
  return highestEdition !== EDITIONS.FREE;
}

/**
 * Return product edition for each hub
 *
 * {
 *   [SALES]: EDITIONS.FREE,
 *   [MARKETING]: EDITIONS.FREE,
 *   [SERVICE]: EDITIONS.FREE,
 *   [OPS]: EDITIONS.STARTER,
 *   [CMS]: EDITIONS.STARTER,
 * }
 */
export function getEditionForHubs(products) {
  const hubsEdition = {};
  for (const hub of Object.values(ONBOARDING_VIEWS)) {
    hubsEdition[hub] = EDITIONS.FREE;
  }
  (products || []).forEach(({
    productApiName
  }) => {
    const {
      hub,
      edition
    } = getProductEditionData(productApiName);
    if (!hub || !edition) {
      return;
    }
    const currentHubEdition = hubsEdition[hub];
    if (editionLevels[edition] > editionLevels[currentHubEdition]) {
      hubsEdition[hub] = edition;
    }
  });
  return hubsEdition;
}

/**
 * Return highest product edition for all user hubs
 *
 * @returns {'free' | 'starter' | 'professional' | 'enterprise'}
 */
export function getEditionForUser(products) {
  const hubsEdition = getEditionForHubs(products);
  let edition = EDITIONS.FREE;
  for (const hubEdition of Object.values(hubsEdition)) {
    if (editionLevels[hubEdition] > editionLevels[edition]) {
      edition = hubEdition;
    }
  }
  return edition;
}
export const findHubByEdition = (desiredHub, desiredEdition, products) => {
  return products.find(({
    productApiName
  }) => {
    const {
      hub,
      edition
    } = getProductEditionData(productApiName);
    return hub === desiredHub && edition === desiredEdition;
  });
};
export const findSubscriptionStartDate = (desiredHub, desiredEdition, products) => {
  const matchingHub = findHubByEdition(desiredHub, desiredEdition, products);
  if (!matchingHub || !matchingHub.subscription || !matchingHub.subscription.startDate || !Array.isArray(matchingHub.subscription.startDate) || matchingHub.subscription.startDate.length !== 3) {
    return null;
  }
  const [year, month, date] = matchingHub.subscription.startDate;

  /**
   * The standard JS month is zero indexed.
   * The ownedProducts month is one indexed.
   */
  const subscriptionStartDate = new Date(year, month - 1, date);
  return subscriptionStartDate;
};
export const hasSubscriptionYoungerThan = (desiredHub, desiredEdition, products, days, comparison = new Date()) => {
  const subscriptionStartDate = findSubscriptionStartDate(desiredHub, desiredEdition, products);
  if (!subscriptionStartDate) {
    return false;
  }
  const pastStartDateThreshold = new Date(new Date(comparison.getTime() - days * ONE_DAY_IN_MS));
  return subscriptionStartDate.getTime() > pastStartDateThreshold.getTime();
};
export const hasNoProOrAboveSubscription = products => {
  const allHubs = getEditionForHubs(products);
  return !Object.values(allHubs).some(edition => EDITIONS.PROFESSIONAL === edition || EDITIONS.ENTERPRISE === edition);
};